import api from './api';

// Uses the TeleFarm administrator session; Messenger tokens are not involved.
const root = '/accounts/onboarding';
const flowPath = (id) => `${root}/${encodeURIComponent(id)}`;
const data = (response) => response.data.data;

const accountOnboardingService = {
  start: (body) => api.post(`${root}/start`, body).then(data),
  get: (id) => api.get(flowPath(id)).then(data),
  code: (id, code) => api.post(`${flowPath(id)}/code`, { code }).then(data),
  password: (id, password) => api.post(`${flowPath(id)}/password`, { password }).then(data),
  cancel: (id) => api.post(`${flowPath(id)}/cancel`, {}).then(data),
};

export default accountOnboardingService;
